import { render, staticRenderFns } from "./RoutineWeekDots.vue?vue&type=template&id=c4e7edc8&scoped=true"
import script from "./RoutineWeekDots.vue?vue&type=script&lang=js"
export * from "./RoutineWeekDots.vue?vue&type=script&lang=js"
import style0 from "./RoutineWeekDots.vue?vue&type=style&index=0&id=c4e7edc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e7edc8",
  null
  
)

export default component.exports